// @ts-nocheck

import { type UserInfo, UserState } from "@b2bportal/auth-api";
import { getObjectKeysAsObject } from "@hopper-b2b/checkout";
import type { PartialHopperCheckoutContext } from "./types";

const hasGuestInformation = (ctx: PartialHopperCheckoutContext) =>
  ctx.auth.guestUser.givenName && ctx.auth.guestUser.surname;

export const AuthGuards = {
  isUserAnonymous: (ctx: PartialHopperCheckoutContext) =>
    (ctx.sessionInfo?.userInfo as UserInfo)?.userState === UserState.Anonymous,
  hasGuestInformation,
  isUserAnonymousAndHasGuestInfo: (ctx: PartialHopperCheckoutContext) =>
    (ctx.sessionInfo?.userInfo as UserInfo)?.userState ===
      UserState.Anonymous && hasGuestInformation(ctx),
  isGuestUser: (ctx: PartialHopperCheckoutContext) =>
    (ctx.sessionInfo?.userInfo as UserInfo)?.userState === UserState.Guest,
};

export const AuthGuardTypes = getObjectKeysAsObject(AuthGuards);
